import {
  MessageService,
  type Chat,
  type GetLatestMessagesData,
  type GetMessagesData,
} from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessagesList = () => {
  const { send: listMessages } = useFetchComposable(
    ({
      after,
      before,
      chatId,
      limit,
    }: {
      after?: string;
      before?: string;
      chatId: Chat['id'];
      limit?: number;
    }) => {
      const query: GetMessagesData['query'] = {
        ...(after ? { after } : {}),
        ...(before ? { before } : {}),
        ...(limit ? { limit } : {}),
      };

      return MessageService.getMessages({ path: { id: chatId }, query });
    },
  );
  const { send: getLatestMessages } = useFetchComposable(
    ({ chatId, limit }: { chatId: Chat['id']; limit?: number }) => {
      const query: GetLatestMessagesData['query'] = limit ? { limit } : {};

      return MessageService.getLatestMessages({ path: { id: chatId }, query });
    },
  );

  return { getLatestMessages, listMessages };
};

export { useMessagesList };
